package com.pincer.core.contracts

import com.pincer.core.contracts.BaseContract
import com.pincer.core.parsePincerException
import com.pincer.core.model.Device
import com.pincer.core.model.tree.Pincer
import com.pincer.core.model.patches.PincerPatch
import kotlinx.serialization.SerializationException

class BaseContractFromRequest(val contract: RequestContract): BaseContract {

    private suspend fun processAndCheck(request: PincerRequest): PincerResponse {
        val response = contract.process(request)
        if (response.pincerException != null) throw response.pincerException
        return response
    }

    override suspend fun device(): Device
        = processAndCheck(PincerRequest(type = "device")).device!!

    override suspend fun principalAnonymous(jwt: String, locale: String?, zone: String?): String
        = processAndCheck(PincerRequest(type = "principalAnonymous", jwt = jwt, locale = locale, zone = zone)).string!!

    override suspend fun principalTriggerCode(jwt: String, credential: String) {
        processAndCheck(PincerRequest(type = "principalTriggerCode", jwt = jwt, credential = credential))
    }

    override suspend fun principalConfirmCode(jwt: String, credential: String, code: String, locale: String?, zone: String?): String
        = processAndCheck(PincerRequest(type = "principalConfirmCode", jwt = jwt, credential = credential, code = code, locale = locale, zone = zone)).string!!

    override suspend fun principalLogout(jwt: String, allDevices: Boolean) {
        processAndCheck(PincerRequest(type = "principalLogout", jwt = jwt, allDevices = allDevices))
    }

    override suspend fun principalWhoAmI(jwt: String): String
        = processAndCheck(PincerRequest(type = "principalWhoAmI", jwt = jwt)).string!!

    override suspend fun get(jwt: String, pid: String): Pincer
        = processAndCheck(PincerRequest(type = "get", jwt = jwt, pid = pid)).pincer!!

    override suspend fun getAt(jwt: String, pid: String, sid: Long): Pincer
        = processAndCheck(PincerRequest(type = "getAt", jwt = jwt, pid = pid, sid = sid)).pincer!!

    override suspend fun getSince(jwt: String, pid: String, sid: Long): PincerPatch
        = processAndCheck(PincerRequest(type = "getSince", jwt = jwt, pid = pid, sid = sid)).pincerPatch!!

    override suspend fun fork(jwt: String, pid: String): String
        = processAndCheck(PincerRequest(type = "fork", jwt = jwt, pid = pid)).string!!

    override suspend fun patch(jwt: String, pid: String, sid: Long, patch: PincerPatch): PincerPatch
        = processAndCheck(PincerRequest(type = "patch", jwt = jwt, pid = pid, sid = sid, patch = patch)).pincerPatch!!

}
